import { Box, Stack, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

const FounderDetails = ({
    image,
    name,
    role,
    linkedIn,
    note,
    backgroundLayerPosition
}) => {
    const theme = useTheme();

    return (
        <>
            <Link 
                to={linkedIn} 
                target='_blank'
                style={{
                    textDecoration: 'none'
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='start'
                    alignItems='center'
                >
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%'
                        }}
                    >
                        <Box
                            sx={{
                                width: '50%',
                                backgroundColor: theme.palette.background.paper,
                                height: '80%',
                                position: 'absolute',
                                zIndex: 0,
                                bottom: 4,
                                borderRadius: '20px 20px 0px 0px',
                                ...backgroundLayerPosition
                            }}
                        />

                        <Box
                            sx={{
                                width: {xs: '50%', md: '75%'},
                                position: 'relative',
                                zIndex: 1,
                                margin: 'auto'
                            }}
                        >
                            <img 
                                src={image} 
                                alt={name}
                                width='100%'
                            />
                        </Box>
                    </Box>

                    <Stack
                        direction='column'
                        justifyContent='center'
                        alignItems='start'
                        width='100%'
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            mt: -0.5,
                            py: 1
                        }}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 16, lg: 20}}
                            textAlign='left'
                            color="white"
                            lineHeight={1.5}
                            px={2}
                        >
                            {name}
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="left"
                            lineHeight={1.5}
                            color={theme.palette.primary.contrastText}
                            px={2}
                        >
                            {role}
                        </Typography>
                    </Stack>

                    <Stack
                        direction='column'
                        justifyContent='center'
                        alignItems='start'
                        width='100%'
                        sx={{
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: '0px 0px 20px 20px',
                            mt: -0.5,
                            py: 2
                        }}
                    >
                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 10, lg: 12}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.primary}
                            px={2}
                        >
                            {note}
                        </Typography>
                    </Stack>
                </Stack>
            </Link>
        </>
    );
}

export default FounderDetails;